import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/production/raw-materials`;

export const productionRawMaterialsAPI = {
  async bootstrap() {
    return apiClient(`${BASE}/bootstrap`);
  },

  async getAll() {
    return apiClient(`${BASE}/`);
  },

  async getById(id) {
    return apiClient(`${BASE}/${id}`);
  },

  async create(data) {
    return apiClient(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async getLots() {
    return apiClient(`${BASE}/lots`);
  },

  async getReceptions() {
    return apiClient(`${BASE}/receptions`);
  },

  async createReception(data) {
    return apiClient(`${BASE}/receptions`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async getIngresos() {
    return apiClient(`${BASE}/ingresos`);
  },

  async getEgresos() {
    return apiClient(`${BASE}/egresos`);
  },

  async getInventoryCounts() {
    return apiClient(`${BASE}/inventory-counts`);
  },

  async getInventoryCount(id) {
    return apiClient(`${BASE}/inventory-counts/${id}`);
  },

  async createInventoryCount(data) {
    return apiClient(`${BASE}/inventory-counts`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async updateInventoryCount(id, data) {
    return apiClient(`${BASE}/inventory-counts/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async confirmInventoryCount(id) {
    return apiClient(`${BASE}/inventory-counts/${id}/confirm`, {
      method: 'POST',
    });
  },
};

export default productionRawMaterialsAPI;
